import { render } from "./CreateStats.vue?vue&type=template&id=32db7076"
import script from "./CreateStats.vue?vue&type=script&lang=js"
export * from "./CreateStats.vue?vue&type=script&lang=js"
script.render = render

export default script